import script from "./PlatMapMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatMapMain.vue?vue&type=script&setup=true&lang=ts"

import "./PlatMapMain.vue?vue&type=style&index=0&id=df2aa604&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df2aa604"]])

export default __exports__